// src/sections/Links.js
import React from 'react';
import './Links.css';

function Links() {
  return (
    <section id="links" className="links-section">
      <div className="links-button-wrapper">
        <a
          href="https://form.run/@tohakusha-v4eFrsWHhCyIoHmhe5iK"
          target="_blank"
          rel="noopener noreferrer"
          className="links-button"
        >
          CONTACT
        </a>
        <a
          href="https://hrmos.co/pages/tohakusha"
          target="_blank"
          rel="noopener noreferrer"
          className="links-button"
        >
          RECRUIT
        </a>
      </div>
    </section>
  );
}

export default Links;
